"use client";

import { ReactNode } from "react";
import LegalPolicyTabs from "@/components/legal/LegalPolicyTabs";

export default function LegalPoliciesLayout({ children }: { children: ReactNode }) {
  return (
    <main className="min-h-screen bg-white pt-[88px] text-[#202020] lg:pt-[108px]">
      <div className="container max-w-[1288px] pb-20 lg:pb-28">
        <div className="flex flex-col gap-8 px-1 lg:flex-row lg:items-start lg:gap-12 lg:px-6">
          <div className="min-w-0 flex-1">{children}</div>
          <aside className="order-first w-full shrink-0 lg:sticky lg:top-[108px] lg:order-none lg:w-[248px]">
            <LegalPolicyTabs />
          </aside>
        </div>
      </div>
    </main>
  );
}
